/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { availabilityRangeResponseSchema } from './availabilityRangeResponseSchema';

export const workloadSchemeWithBaseRangeSchema = z.object({
  archivedAt: z.iso.datetime().nullish(),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  demotedDefaultSchemeId: z.int().nullish(),
  description: z.string().nullish(),
  id: z.int(),
  instanceId: z.string().nullish(),
  isDefault: z.boolean(),
  lastSyncedAt: z.iso.datetime().nullish(),
  locationIds: z.array(z.int()),
  memberCount: z.int(),
  name: z.string(),
  organizationId: z.string(),
  get range() {
    return availabilityRangeResponseSchema;
  },
  skippedSyncedResourceIds: z.array(z.int()).nullish(),
  sourceId: z.string().nullish(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
